import React from 'react'

import getAllPartTypes from '../../../modules/redux/catalogs/getAllPartTypes'
import { useSelector } from '../../../modules/store/customSelector'
import { storeDispatchTypes } from '../../../modules/store/storeDispatchTypes'
import TableHeadSelectSearch from '../../_atoms/TableHeadSelectSearch/TableHeadSelectSearch'

const TableHeadTypeSearchParts = () => {
    const partTypes = useSelector(state => state.partList.partTypes)
    const typeIdFilter = useSelector(state => state.partList.filters.typeId)

    return (
        <TableHeadSelectSearch
            slice={'partList'}
            tableHead={'Тип запчасти'}
            placeholder={'Выберите тип'}
            actionType={storeDispatchTypes.setTypeFilterParts}
            options={partTypes}
            filterId={typeIdFilter}
            searchOptions={getAllPartTypes}
        />
    )
}

export default TableHeadTypeSearchParts

